var level5xml = `
<xml xmlns="https://developers.google.com/blockly/xml">
<variables>
<variable id="P5~v6L*g7-|,6_0@.yhM">list_of_food</variable>
<variable id="mRlAm5k+~6Mb{Kb]-1Li">list_of_food_in_fridge</variable>
</variables>
<block type="procedures_defreturn" id="*9PlFoeasS:cDZP+!kyC" x="-12" y="12">
<mutation>
<arg name="list_of_food" varid="P5~v6L*g7-|,6_0@.yhM"/>
</mutation>
<field name="NAME">add_food_to_fridge</field>
<comment pinned="false" h="80" w="160">This function takes in a list of food and adds it to a list of food in the fridge</comment>
<statement name="STACK">
<block type="variables_set" id=")|[JWbuViX!IMb]=8FVk">
<field name="VAR" id="mRlAm5k+~6Mb{Kb]-1Li">list_of_food_in_fridge</field>
<value name="VALUE">
<block type="lists_create_with" id="]5g:Pdd-#.F7t}LV~K4*">
<mutation items="0"/>
</block>
</value>
<next>
<block type="controls_whileUntil" id="NGH{RKTEIEWd,Znp%9w">
<field name="MODE">WHILE</field>
<value name="BOOL">
<block type="logic_negate" id="mYjRg[_r!Yc$r)VOly8D">
<value name="BOOL">
<block type="lists_isEmpty" id="7@A(YP%4)]DO2%cETOj">
<value name="VALUE">
<block type="variables_get" id="-zAZ0ky$3lY,9Hk|I##+">
<field name="VAR" id="P5~v6L*g7-|,6_0@.yhM">list_of_food</field>
</block>
</value>
</block>
</value>
</block>
</value>
<statement name="DO">
<block type="lists_setIndex" id="0+NAN-W_~Q[:_oYlh$f+">
<mutation at="false"/>
<field name="MODE">INSERT</field>
<field name="WHERE">FIRST</field>
<value name="LIST">
<block type="variables_get" id="VHC??^r)x87rBR=E)6eV">
<field name="VAR" id="mRlAm5k+~6Mb{Kb]-1Li">list_of_food_in_fridge</field>
</block>
</value>
<value name="TO">
<block type="lists_getIndex" id="QN)}pP@jV/v4[N+8dLv]">
<mutation statement="false" at="false"/>
<field name="MODE">GET_REMOVE</field>
<field name="WHERE">FIRST</field>
<value name="VALUE">
<block type="variables_get" id="43SxW1o.)6G?:+L22A$)">
<field name="VAR" id="P5~v6L*g7-|,6_0@.yhM">list_of_food</field>
</block>
</value>
</block>
</value>
</block>
</statement>
</block>
</next>
</block>
</statement>
<value name="RETURN">
<block type="variables_get" id="c_jb/p+P~[^pbY!f]7:">
<field name="VAR" id="mRlAm5k+~6Mb{Kb]-1Li">list_of_food_in_fridge</field>
</block>
</value>
</block>
<block type="text_print" id="aWnF3=hqTUYx|2+EVMDB" x="38" y="213">
<value name="TEXT">
<block type="procedures_callreturn" id="bvFQ.HPQ8w$|k^MRi..3">
<mutation name="add_food_to_fridge">
<arg name="list_of_food"/>
</mutation>
<value name="ARG0">
<block type="lists_create_with" id="NN~0a%Ydd/^BYhd)E0fM">
<mutation items="3"/>
<value name="ADD0">
<block type="text" id="6#-OQl+|JNO}w5X99zY">
<field name="TEXT">bananas</field>
</block>
</value>
<value name="ADD1">
<block type="text" id="1U,sz#yWN{:r_4^BA3uL">
<field name="TEXT">milk</field>
</block>
</value>
<value name="ADD2">
<block type="text" id="/}c;/nLp6q6#)8W$a[uo">
<field name="TEXT">apple juice</field>
</block>
</value>
</block>
</value>
</block>
</value>
</block>
</xml>
`

export default level5xml 